import { render, staticRenderFns } from "./StockLogo.vue?vue&type=template&id=65be0be0&scoped=true"
import script from "./StockLogo.vue?vue&type=script&lang=js"
export * from "./StockLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_coffee-script@1.12.7_css-loader@5.2.7_webpack@5.75.0__ej_a2druqk6gflmaox3z523qmpkfq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65be0be0",
  null
  
)

export default component.exports